export default "__VITE_ASSET__BC4bLs0x__"